import { useMutation } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { KeepInTouchTemplateRequest } from '../../models/KeepInTouchAgent';
import { useUserSession } from '../../models/hooks/appStateHooks';
import {
	invalidateKeepInTouchTemplatesQueries,
	updateKeepInTouchTemplatesRQCache,
} from './useKeepInTouchTemplatesQuery';

export function useCreateKeepInTouchTemplateMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: (template: Api.KeepInTouchTemplate) => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();
	return useMutation({
		mutationFn: (request: KeepInTouchTemplateRequest) => {
			return userSession.webServiceHelper.callAsync<Api.KeepInTouchTemplate>('keepInTouch/templates', 'POST', request);
		},
		onError,
		onSuccess: template => {
			updateKeepInTouchTemplatesRQCache(template);
			onSuccess?.(template);
		},
		onSettled: () => {
			invalidateKeepInTouchTemplatesQueries();
		},
	});
}
